export default __webpack_public_path__ + "static/media/explosion.00384a84.png";